import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { selectSingleElement, validateDesign } from "../../actions/index";
import { bindActionCreators } from "redux";
import Layers from "./Layers";
import Dialog from "../Dialog";

class CanvasContainer extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      isMobile: window.innerWidth <= 768
    };
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
    window.addEventListener("resize", this.handleResize);

    // Validate design on initial load
    this.props.validateDesign();
  }

  componentDidUpdate(prevProps) {
    // Validate when layer set changes
    if (prevProps.design?.layer_set !== this.props.design?.layer_set) {
      this.props.validateDesign();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
    window.removeEventListener("resize", this.handleResize);
  }

  handleClick = (event) => {
    // Check for clicks inside canvas area but outside image and text elements to deselect elements
    if (
      this.containerRef.current &&
      this.containerRef.current.contains(event.target) &&
      !event.shiftKey
    ) {
      if (
        !event.target.classList.contains("text-element__image") &&
        !event.target.classList.contains("image-element__image") &&
        !event.target.classList.contains("clipart-size__item") &&
        !event.target.classList.contains("clipart-size__container")
      ) {
        this.props.selectSingleElement({ itemType: null });
      }
    }
  };

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  render() {
    // Only apply special mobile styles on mobile devices when drawer is open
    let containerStyle = {};

    if (this.state.isMobile && this.props.mobileDrawer.isOpen) {
      containerStyle = {
        top: "30%",
        transform: "translate(-50%, -50%) scale(0.55)",
        WebkitTransform: "translate(-50%, -50%) scale(0.55)"
      };
    }

    return (
      <div
        className="canvas__container"
        id="canvas-container"
        ref={this.containerRef}
        style={containerStyle}
      >
        <Layers
          disableInteractivity={false}
          guidesVisible={this.props.guidesVisible}
          handleHideInitialTips={this.props.handleHideInitialTips}
          onShow2ndTip={this.props.onShow2ndTip}
          didShow2ndTip={this.props.didShow2ndTip}
          handleHide2ndTip={this.props.handleHide2ndTip}
        />

        {this.props.dialog.isVisible && (
          <Dialog
            dialog={this.props.dialog}
            onHideDialog={this.props.onHideDialog}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mobileDrawer: state.mobileDrawer,
    design: state.design.present
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectSingleElement,
      validateDesign
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CanvasContainer);
